import React from 'react';

import './Button.scss';

function Button({children, type, className, handleClick, disabled}) {
    if(handleClick){
        return(
            <button onClick={handleClick} className={`button ${className || ''}`} type={type || null} disabled={!!disabled}>
                {children}
            </button>
        )
    }
    return(
        <button className={`button ${className || ''}`} type={type || null} disabled={!!disabled}>
            {children}
        </button>
    )
}

export default Button;